import { useEffect, useState } from "react";
import { isValidArray } from "../../../Layout/Common/common";
import { FeatureContainer } from "./featureContainer";

export const ProductPageDescription = ({ params }) => {
  const [feature, setFeature] = useState(null);
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (params) {
      if (params.feature && params.feature != "") setFeature(params.feature);
      setDescription(params.familyDesc);
    }
  }, []);
  return (
    <div className="productFeatures mt-3">
      {feature ? (
        <FeatureContainer htmlString={feature} location="top" />
      ) : (
        <div className="prosection-aboutDetails">
          <p dangerouslySetInnerHTML={{ __html: description ?? "" }} />
        </div>
      )}
    </div>
  );
};
